var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { attrs: { bordered: false } },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("收款模式设置"),
              ]),
              _c("a-alert", {
                staticStyle: { "margin-bottom": "16px" },
                attrs: {
                  type: "warning",
                  "show-icon": "",
                  message: "合规提示",
                  description:
                    "代收模式建议仅用于直营店（同一法人内部资金调拨）；加盟店（独立法人）使用代收存在二清监管风险，请谨慎选择",
                },
              }),
              _c(
                "a-form",
                { attrs: { layout: "inline" } },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 7, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "所属门店" } },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "220px" },
                                  attrs: { placeholder: "请选择门店" },
                                  on: { change: _vm.onFundStoreChange },
                                  model: {
                                    value: _vm.fundStoreId,
                                    callback: function ($$v) {
                                      _vm.fundStoreId = $$v
                                    },
                                    expression: "fundStoreId",
                                  },
                                },
                                _vm._l(_vm.storeList, function (s) {
                                  return _c(
                                    "a-select-option",
                                    { key: s.id, attrs: { value: s.id } },
                                    [_vm._v(_vm._s(s.name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 17, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "允许门店收款" } },
                            [
                              _c("a-switch", {
                                attrs: {
                                  "checked-children": "启用",
                                  "un-checked-children": "关闭",
                                  disabled: _vm.isFundStoreMain,
                                },
                                model: {
                                  value: _vm.fundAllowPaySwitch,
                                  callback: function ($$v) {
                                    _vm.fundAllowPaySwitch = $$v
                                  },
                                  expression: "fundAllowPaySwitch",
                                },
                              }),
                              _c("span", { staticClass: "fund-switch-tip" }, [
                                _vm._v(
                                  "（开启：门店可自己进件直收；关闭：进件由总店统一管理、货款由总店代收）"
                                ),
                              ]),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "12px" },
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.fundSaving,
                                  },
                                  on: { click: _vm.handleSaveFund },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "field-tip" }, [
                _vm._v(
                  "门店直收前置条件：门店已进件特约商户，未进件无法开启直收"
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-col",
        { staticStyle: { "margin-top": "12px" }, attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { attrs: { bordered: false } },
            [
              _c(
                "a-tabs",
                {
                  on: { change: _vm.onTabChange },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    { key: "settle", attrs: { tab: "对账计提" } },
                    [
                      _vm.isFundStoreMain
                        ? [
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v("服务费率设置"),
                            ]),
                            _c(
                              "a-form",
                              { staticClass: "setting-form" },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "平台抽佣模式",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c(
                                      "a-radio-group",
                                      {
                                        model: {
                                          value: _vm.commissionForm.rule,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.commissionForm,
                                              "rule",
                                              $$v
                                            )
                                          },
                                          expression: "commissionForm.rule",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-radio",
                                          { attrs: { value: "2" } },
                                          [_vm._v("自定义抽佣设置")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "field-tip" }, [
                                      _vm._v(
                                        "温馨提示：此抽佣模式建议在单商户下使用"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm.commissionForm.rule === "2"
                                  ? _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "佣金计算方式",
                                          labelCol: _vm.formLabelCol,
                                          wrapperCol: _vm.formWrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-radio-group",
                                          {
                                            model: {
                                              value: _vm.commissionForm.type,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.commissionForm,
                                                  "type",
                                                  $$v
                                                )
                                              },
                                              expression: "commissionForm.type",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-radio",
                                              { attrs: { value: "1" } },
                                              [_vm._v("订单百分比抽成")]
                                            ),
                                            _c(
                                              "a-radio",
                                              { attrs: { value: "2" } },
                                              [_vm._v("按固定金额")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm.commissionForm.rule === "2" &&
                            _vm.commissionForm.type === "1"
                              ? _c(
                                  "a-form",
                                  { staticClass: "setting-form" },
                                  _vm._l(_vm.commissionItems, function (item) {
                                    return _c(
                                      "a-form-item",
                                      {
                                        key: item.key,
                                        attrs: {
                                          label: item.label + "抽佣比例",
                                          labelCol: _vm.formLabelCol,
                                          wrapperCol: _vm.formWrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "220px" },
                                          attrs: {
                                            addonBefore: "平台抽佣",
                                            addonAfter: "%",
                                          },
                                          model: {
                                            value:
                                              _vm.commissionForm[
                                                item.key + "PlatformProportion"
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.commissionForm,
                                                item.key + "PlatformProportion",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "commissionForm[item.key + 'PlatformProportion']",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "prop-sep" },
                                          [_vm._v(" / ")]
                                        ),
                                        _c("a-input", {
                                          staticStyle: { width: "220px" },
                                          attrs: {
                                            value: _vm.getStoreProportion(
                                              item.key
                                            ),
                                            addonBefore: "商家获得",
                                            addonAfter: "%",
                                            disabled: "",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "prop-sep" },
                                          [_vm._v(" / ")]
                                        ),
                                        _c("a-input", {
                                          staticStyle: { width: "220px" },
                                          attrs: {
                                            addonBefore: "最低抽佣",
                                            addonAfter: "元",
                                          },
                                          model: {
                                            value:
                                              _vm.commissionForm[
                                                item.key + "DownMoney"
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.commissionForm,
                                                item.key + "DownMoney",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "commissionForm[item.key + 'DownMoney']",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _vm.commissionForm.rule === "2" &&
                            _vm.commissionForm.type === "2"
                              ? _c(
                                  "a-form",
                                  { staticClass: "setting-form" },
                                  _vm._l(_vm.commissionItems, function (item) {
                                    return _c(
                                      "a-form-item",
                                      {
                                        key: item.key,
                                        attrs: {
                                          label: item.label + "抽成金额",
                                          labelCol: _vm.formLabelCol,
                                          wrapperCol: _vm.formWrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "220px" },
                                          attrs: { addonAfter: "元" },
                                          model: {
                                            value:
                                              _vm.commissionForm[
                                                item.key + "FixedMoney"
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.commissionForm,
                                                item.key + "FixedMoney",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "commissionForm[item.key + 'FixedMoney']",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "form-footer" },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      loading: _vm.commissionSaving,
                                    },
                                    on: { click: _vm.handleSaveCommission },
                                  },
                                  [_vm._v("保存")]
                                ),
                              ],
                              1
                            ),
                            _c("a-divider", {
                              staticStyle: { margin: "8px 0 16px" },
                            }),
                          ]
                        : _vm._e(),
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("周期计提"),
                      ]),
                      _c("div", { staticClass: "field-tip settle-tip" }, [
                        _vm._v(
                          "计提明细为对账参考，资金兑现请走门店提现申请-审批流程"
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "table-page-search-wrapper" },
                        [
                          _c(
                            "a-form",
                            { attrs: { layout: "inline" } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "结算月份" } },
                                [
                                  _c("a-month-picker", {
                                    attrs: {
                                      format: "YYYY-MM",
                                      "allow-clear": false,
                                    },
                                    model: {
                                      value: _vm.settleMonth,
                                      callback: function ($$v) {
                                        _vm.settleMonth = $$v
                                      },
                                      expression: "settleMonth",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: {
                                    type: "primary",
                                    icon: "search",
                                    loading: _vm.previewLoading,
                                  },
                                  on: { click: _vm.handlePreview },
                                },
                                [_vm._v("预览计提")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "storeId",
                          columns: _vm.previewColumns,
                          dataSource: _vm.previewList,
                          loading: _vm.previewLoading,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "modeSlot",
                            fn: function (text, record) {
                              return [
                                String(record.receiveMode) === "2"
                                  ? _c("a-tag", { attrs: { color: "green" } }, [
                                      _vm._v("直收"),
                                    ])
                                  : _c("a-tag", { attrs: { color: "blue" } }, [
                                      _vm._v("代收"),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("a-divider", { staticStyle: { margin: "16px 0" } }),
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("结算历史"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "table-page-search-wrapper" },
                        [
                          _c(
                            "a-form",
                            { attrs: { layout: "inline" } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "结算月份" } },
                                [
                                  _c("a-month-picker", {
                                    attrs: {
                                      format: "YYYY-MM",
                                      "allow-clear": false,
                                    },
                                    model: {
                                      value: _vm.historyMonth,
                                      callback: function ($$v) {
                                        _vm.historyMonth = $$v
                                      },
                                      expression: "historyMonth",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: {
                                    type: "primary",
                                    icon: "search",
                                    loading: _vm.historyLoading,
                                  },
                                  on: { click: _vm.loadHistory },
                                },
                                [_vm._v("查询")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: (r) => r.storeId + "-" + r.cycleStart,
                          columns: _vm.historyColumns,
                          dataSource: _vm.historyList,
                          loading: _vm.historyLoading,
                          pagination: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "srSlot",
                            fn: function (text) {
                              return [
                                text
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "bill-no",
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyText(text)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(text))]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                          {
                            key: "zcSlot",
                            fn: function (text) {
                              return [
                                text
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "bill-no",
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyText(text)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(text))]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                          {
                            key: "fkSlot",
                            fn: function (text) {
                              return [
                                text
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "bill-no",
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyText(text)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(text))]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                          {
                            key: "skSlot",
                            fn: function (text) {
                              return [
                                text
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "bill-no",
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyText(text)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(text))]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    2
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "withdraw", attrs: { tab: "提现审批" } },
                    [
                      _c(
                        "div",
                        { staticClass: "table-page-search-wrapper" },
                        [
                          _c(
                            "a-form",
                            { attrs: { layout: "inline" } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "状态" } },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "130px" },
                                      model: {
                                        value: _vm.withdrawQuery.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.withdrawQuery,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "withdrawQuery.status",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "1" } },
                                        [_vm._v("待审批")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "2" } },
                                        [_vm._v("已通过")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "3" } },
                                        [_vm._v("已驳回")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "4" } },
                                        [_vm._v("已支付")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "" } },
                                        [_vm._v("全部")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { type: "primary", icon: "search" },
                                  on: { click: _vm.onWithdrawSearch },
                                },
                                [_vm._v("查询")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-table", {
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.withdrawColumns,
                          dataSource: _vm.withdrawList,
                          loading: _vm.withdrawLoading,
                          pagination: _vm.withdrawPagination,
                        },
                        on: { change: _vm.onWithdrawPageChange },
                        scopedSlots: _vm._u([
                          {
                            key: "amountSlot",
                            fn: function (text) {
                              return [
                                _c("span", { staticClass: "amount-red" }, [
                                  _vm._v("¥" + _vm._s(_vm.fmtMoney(text))),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "withdrawStatus",
                            fn: function (text) {
                              return [
                                _c(
                                  "a-tag",
                                  {
                                    attrs: {
                                      color: (_vm.withdrawStatusMap[text] || {})
                                        .color,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        (_vm.withdrawStatusMap[text] || {})
                                          .text || text
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "withdrawAction",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  record.status === "1"
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAuditPass(
                                                  record
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("通过")]
                                        ),
                                        _c("a-divider", {
                                          attrs: { type: "vertical" },
                                        }),
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAuditReject(
                                                  record
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("驳回")]
                                        ),
                                      ]
                                    : record.status === "2"
                                    ? _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleMarkPaid(record)
                                            },
                                          },
                                        },
                                        [_vm._v("标记已支付")]
                                      )
                                    : _c("span", [_vm._v("-")]),
                                ],
                                2
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "驳回原因",
            visible: _vm.rejectVisible,
            confirmLoading: _vm.auditLoading,
          },
          on: {
            ok: _vm.handleRejectSubmit,
            cancel: function ($event) {
              _vm.rejectVisible = false
            },
          },
        },
        [
          _c("a-textarea", {
            attrs: {
              rows: 3,
              maxLength: 200,
              placeholder: "请填写驳回原因（必填）",
            },
            model: {
              value: _vm.rejectReason,
              callback: function ($$v) {
                _vm.rejectReason = $$v
              },
              expression: "rejectReason",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }